import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cart",
  "use": "cart-usage",
  "viewBox": "0 0 19 17",
  "content": "<symbol viewBox=\"0 0 19 17\" id=\"cart\"><path d=\"M6.167 13.4c-1.009 0-1.834.81-1.834 1.8S5.158 17 6.167 17C7.175 17 8 16.19 8 15.2s-.825-1.8-1.833-1.8zM0 0v2h3l2 6v2c-.092.27 0 .73 0 1 0 .99.492 1.909 1.5 1.909L17 13v-2H7c-.092 0 0 .09 0 0v-1h7c.733 0 1.725-.46 2-1l2.817-5.85C19 2.97 19 2.88 19 2.7c0-.54-.45-.7-1-.7H5L3.692 0H0zm15.333 13.4c-1.008 0-1.833.81-1.833 1.8s.825 1.8 1.833 1.8c1.009 0 1.834-.81 1.834-1.8s-.825-1.8-1.834-1.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol